<template>
    <div class="reporting-charts-pie">
        <highcharts :options="chartOptions"/>
    </div>
</template>

<script>
import ChartConsts from '@/providers/ChartConsts'

export default {
    name: 'ReportingChartPie',
    props: {
        title: String,
        data: Array,
        seriesName: String,
        noDataString: String
    },
    computed: {
        chartOptions () {
            return this.getBaseOptions()
        }
    },
    methods: {
        getBaseOptions () {
            return {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie'
                },
                lang: {
                    noData: this.noDataString ?? 'No data to display'
                },
                plotOptions: {
                    pie: {
                        dataLabels: { enabled: false },
                        showInLegend: true
                    }
                },
                legend: { enabled: true },
                title: {
                    text: this.title
                },
                credits: { enabled: false },
                colors: ChartConsts.colors,
                series: [{
                    name: this.seriesName,
                    colorByPoint: true,
                    data: this.data
                }]
            }
        }
    }
}
</script>

<style scoped>

</style>